import React, {Component} from 'react';
const { connect } = require('react-redux');

import Footer from '../../components/Footer';
import HeaderWallet from 'components/wallet/HeaderWallet';
import WalletProducts from 'components/wallet/WalletProducts';

import 'sass/member/wallet/wallet.scss';

class Wallet extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {location} = this.props;

        return (
            <div id="wrapper">
                {/* Let HeaderWallet/WalletProducts update on location/locale change */}
                <HeaderWallet location={location}/>
                <WalletProducts location={location}/>
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({

    }),({

    })
)(Wallet)


// WEBPACK FOOTER //
// ./src/containers/member/Wallet.js